import { connect } from "react-redux";
import get from "lodash/get";

import {
  getLogisticTrips as onGetLogisticTrips,
  getLogisticTrip as onGetLogisticTrip,
  createLogisticTrip as onCreateLogisticTrip,
  deleteLogisticTrip as onDeleteLogisticTrip,
  selectLogisticTrip as onSelectLogisticTrip,
  updateLogisticTrip as onUpdateLogisticTrip,
  copyLogisticTrip as onCopyLogisticTrip,
  addUnitLogisticTrip as onAddUnitLogisticTrip,
  deleteUnitLogisticTrip as onDeleteUnitLogisticTrip,
  getLogisticTripGeoJson as onGetLogisticTripGeoJson,
  updateLogisticTripAlarm as onUpdateLogisticTripAlarm,
} from "./../../actions/logisticTripsActions";

const mapStateToProps = (state) => ({
  logisticTripsDataState: state.logisticTrips.logisticTripsDataState,
  logisticTripDataState: state.logisticTrips.logisticTripDataState,
  logisticTripGeoJsonDataState: state.logisticTrips.logisticTripGeoJsonDataState,
  logisticCreateTripsDataState: state.logisticTrips.logisticCreateTripsDataState,
  logisticDeleteTripsDataState: state.logisticTrips.logisticDeleteTripsDataState,
  logisticUpdateTripsDataState: state.logisticTrips.logisticUpdateTripsDataState,
  logisticCopyTripDataState: state.logisticTrips.logisticCopyTripDataState,
  logisticAddUnitTripDataState: state.logisticTrips.logisticAddUnitTripDataState,
  logisticDeleteUnitTripDataState: state.logisticTrips.logisticDeleteUnitTripDataState,
  logisticTripGeojsonDataState: state.logisticTrips.logisticTripGeojsonDataState,
  logisticUpdateTripAlarmDataState: state.logisticTrips.logisticUpdateTripAlarmDataState,
  logisticTrips: get(state, ["logisticTrips", "logisticTrips"], []),
  logisticSelectedTrip: get(state, ["logisticTrips", "logisticSelectedTrip"], null),
  errors: get(state, ["logisticTrips", "errors"], []),
});

const mapDispatchToProps = {
  onGetLogisticTrips,
  onGetLogisticTrip,
  onCreateLogisticTrip,
  onDeleteLogisticTrip,
  onSelectLogisticTrip,
  onUpdateLogisticTrip,
  onCopyLogisticTrip,
  onAddUnitLogisticTrip,
  onDeleteUnitLogisticTrip,
  onGetLogisticTripGeoJson,
  onUpdateLogisticTripAlarm,
};

const withLogisticTrips = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withLogisticTrips };
